import { UPS_CONNECT_REQUEST, UPS_CONNECT_SUCCESS, UPS_CONNECT_FAILURE, UPS_DISCONNECT_REQUEST, UPS_DISCONNECT_SUCCESS, UPS_DISCONNECT_FAILURE } from '../actions/upsActions';

const initialState = {
  connecting: false,
  connected: false,
  lastMessage: null,
  error: null,
};

export default function upsReducer(state = initialState, action) {
  switch (action.type) {
    case UPS_CONNECT_REQUEST:
      return { ...state, connecting: true, error: null, lastMessage: null };
    case UPS_CONNECT_SUCCESS:
      return { ...state, connecting: false, connected: true, lastMessage: action.payload?.message || 'Connected' };
    case UPS_CONNECT_FAILURE:
      return { ...state, connecting: false, error: action.error };
    case UPS_DISCONNECT_REQUEST:
      return { ...state, connecting: true, error: null };
    case UPS_DISCONNECT_SUCCESS:
      return { ...state, connecting: false, connected: false, lastMessage: action.payload?.message || 'Disconnected' };
    case UPS_DISCONNECT_FAILURE:
      return { ...state, connecting: false, error: action.error };
    default:
      return state;
  }
}


